import React from "react";

const KYCLanding = ({authStarted}) => {
  return (
    <>
      <section className="container">
        <div className="row py-lg-5 py-3">
          <div className="mx-auto text-center ">
            <h1 className="py-2">Verify</h1>
            <p className="fs-4">
              To complete your retail order you need <span className="fw-bold fs-2">Tier 2</span> verification,
              please prepare the following documents
            </p>
          </div>
        </div>
      </section>
      <div className="album bg-light">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            <div className="col py-2 my-0">
              <div className="verification-item-container card-body bg-white shadow-sm">
                <img 
                  className="verification-item-img" 
                  src={require("../assets/img/drivers-license-front.svg").default} 
                />
              </div>
              <div className="text-center pt-2 fs-5">
                ID - Front Side
              </div>
            </div>
            <div className="col py-2 my-0">
              <div className="verification-item-container card-body bg-white shadow-sm">
                <img 
                  className="verification-item-img" 
                  src={require("../assets/img/drivers-license-back.svg").default} 
                />
              </div>
              <div className="text-center pt-2 fs-5">
                ID - Back Side
              </div>
            </div>
            <div className="col py-2 my-0">
              <div className="verification-item-container card-body bg-white shadow-sm">
                <img 
                  className="verification-item-img" 
                  src={require("../assets/img/camera.svg").default} 
                />
              </div>
              <div className="text-center pt-2 fs-5">
                Selfie
              </div>
            </div>
          </div>
        </div>
        <div className="span2 d-flex justify-content-center py-4">
          <button
            className="btn btn-block verification-button-auth"
            onClick={authStarted}
          >
            <span className="pb-1 fs-5">BEGIN AUTHENTICATION</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default KYCLanding;
